import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { TextFilter } from '@ui/table-modifier/filters/Text';
export const ActionFilter = (props) => React.createElement(TextFilter, Object.assign({ placeholder: COPY_SPECIFIC.SEARCH_ACTIONS }, props));
